<script setup lang="ts">
import type { LegendItem } from "@/compliance_groups/fixture/derive";
import { FILL } from "@/compliance_groups/fixture/fills";

defineProps<{ legend: LegendItem[] }>();
</script>

<template>
  <div class="d-flex flex-wrap gap-3 mt-3">
    <span
      v-for="item in legend"
      :key="item.label"
      class="d-flex align-items-center gap-2 text-body-secondary small"
    >
      <span class="cg-swatch" :style="{ background: FILL[item.fill] }" />{{
        item.label
      }}
    </span>
  </div>
</template>

<style scoped lang="scss">
.cg-swatch {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  display: inline-block;
}
</style>
